module.exports = __webpack_public_path__ + "img/311.19091cc7.svg";